import { render } from "./BarcodeLabelList.vue?vue&type=template&id=22c8e278&scoped=true"
import script from "./BarcodeLabelList.vue?vue&type=script&lang=ts"
export * from "./BarcodeLabelList.vue?vue&type=script&lang=ts"

import "./BarcodeLabelList.vue?vue&type=style&index=0&id=22c8e278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22c8e278"

export default script